import sourceNodes from './sourceNodes';

export default sourceNodes;
